import { Box, Tooltip, Zoom } from "@mui/material";

import ResendConfigIconButton from "../../../common/components/icons/ResendConfigIconButton";
import { useSyncShadow } from "../../model-manager/hooks/useSyncShadow";
import {
  errorNotification,
  successNotification,
} from "../../../common/variables/notification";

interface IResendConfigContainerProps {
  nodeId: string;
  name: string;
}

const ResendConfigContainer = ({
  nodeId,
  name,
}: IResendConfigContainerProps): JSX.Element => {
  const { syncShadowsForNode, loading } = useSyncShadow();

  const handleClick = async (): Promise<void> => {
    try {
      await syncShadowsForNode(nodeId);

      successNotification(`${name} node configuration sent`);
    } catch {
      errorNotification(
        `Something went wrong sending configuration to ${name}`
      );
    }
  };

  return (
    <Tooltip
      TransitionComponent={Zoom}
      arrow
      disableInteractive
      placement="left"
      title="Resend node configuration"
    >
      <Box
        component="span"
        sx={{
          height: "32px",
          opacity: loading ? 0.5 : 1,
          pointerEvents: loading ? "none" : "auto",
        }}
      >
        <ResendConfigIconButton onClick={handleClick} />
      </Box>
    </Tooltip>
  );
};

export default ResendConfigContainer;
